import React from 'react';
import { Button, Text } from '@components';
import {
  Wrapper,
  StyledContainer,
  StyledVideo,
  Shadow,
  Head,
  StyledTitle,
  Link,
  Textures,
  Value,
  Models } from './styles';
import poster from './poster.webp';
import videoWebm from './video.webm';
import videoMpeg from './video.mp4';

export interface PromoProps {
  handleClick?: () => void;
}

const Promo: React.FC<PromoProps> = ({ handleClick }) => (
  <Wrapper>
    <StyledVideo
      poster={poster}
      webm={videoWebm}
      mpeg={videoMpeg}
    />
    <Shadow />
    <StyledContainer align={'bottom'} absolute>
      <Head>
        <StyledTitle as={'h1'} level={'1'}>
          Собирай цифрового
          себя сколько угодно
        </StyledTitle>
        <Link>
          <Button
            icon={'arrow-right'}
            fullWidth
            onClick={handleClick}
          >
            Конструктор аватаров
          </Button>
        </Link>
        <Textures>
          <Value>7500+</Value>
          <Text level={'1'} colorName={'textLittleTransparency'}>текстур</Text>
        </Textures>
        <Models>
          <Value>2500+</Value>
          <Text level={'1'} colorName={'textLittleTransparency'}>моделей</Text>
        </Models>
      </Head>
    </StyledContainer>
  </Wrapper>
);

export { Promo };
